import { GuideBoolean } from 'components/admin/input/GuideBoolean';
import { EColors2, EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    label?: string;
    value: boolean;
    onChange?: (value: boolean) => void;
    className?: string;
}

export const GuideInputBoolean = (props: Props): JSX.Element => {
    return (
        <S_GuideInputBoolean className={props.className}>
            <S_Label>
                {props.label && <S_LabelText>{props.label}</S_LabelText>}
                <S_Options>
                    <GuideBoolean selected={props.value} onChange={props.onChange} />
                </S_Options>
            </S_Label>
        </S_GuideInputBoolean>
    );
};

const S_GuideInputBoolean = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const S_Label = styled.label`
    display: block;
`;

const S_LabelText = styled.div`
    color: ${EColors2.DARK};
    font-size: 16px;
    margin: 0 0 12px 0;
    font-family: ${EFonts.Medium};
`;

const S_Options = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
`;
